var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "emd-flex-grow_1 emd-flex-shrink_1 emd-flex emd-overflow_hidden",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "emd-container__content emd-flex emd-justify_space-between emd-overflow_hidden",
        },
        [
          _vm.errors.length
            ? _c(
                "emd-alert",
                {
                  attrs: {
                    title: _vm.$t("errorMsg"),
                    variant: "danger",
                    autoclose: false,
                  },
                  on: {
                    cancel: function ($event) {
                      _vm.errors = []
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "content" }, slot: "content" },
                    _vm._l(_vm.errors, function (error, index) {
                      return _c("p", { key: index }, [
                        _vm._v(" " + _vm._s(error) + " "),
                      ])
                    }),
                    0
                  ),
                ]
              )
            : _vm._e(),
          _vm.isLoading || !_vm.employeeTypes
            ? _c(
                "div",
                { staticClass: "eu-pa_6 eu-align_center" },
                [_c("emd-loader", { attrs: { type: "_invert" } })],
                1
              )
            : _c(
                "form",
                {
                  staticClass:
                    "emd-flex-grow_1 emd-flex-shrink_1 emd-flex emd-overflow_hidden",
                  attrs: { id: "form-user-invite" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.handleForm.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "eu-mt_4 emd-flex-grow_1 emd-overflow-y_auto",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "emd-form-group",
                          class: { _state_error: _vm.fields.email.hasError },
                        },
                        [
                          _c("label", { staticClass: "emd-label" }, [
                            _vm._v(_vm._s(_vm.$t("email"))),
                          ]),
                          _c("input", {
                            staticClass: "emd-input eu-my_1",
                            attrs: { type: "email", disabled: "" },
                            domProps: { value: _vm.fields.email.value },
                          }),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "emd-form-group",
                          class: {
                            _state_error: _vm.fields.first_name.hasError,
                          },
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label",
                              attrs: { for: "first_name" },
                            },
                            [_vm._v(_vm._s(_vm.$t("firstName")))]
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.fields.first_name.value,
                                expression: "fields.first_name.value",
                              },
                            ],
                            staticClass: "emd-input eu-my_1",
                            attrs: {
                              id: "first_name",
                              type: "text",
                              disabled: _vm.activeStep.inviteSetAsEmployee,
                            },
                            domProps: { value: _vm.fields.first_name.value },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.fields.first_name,
                                    "value",
                                    $event.target.value
                                  )
                                },
                                function ($event) {
                                  _vm.fields.first_name.errors =
                                    _vm.getFeedbackError("first_name")
                                },
                              ],
                            },
                          }),
                          _vm._l(
                            _vm.fields.first_name.errors,
                            function (error, key) {
                              return _c(
                                "p",
                                { key: key, staticClass: "emd-input-feedback" },
                                [_vm._v(" " + _vm._s(error) + " ")]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "emd-form-group",
                          class: {
                            _state_error: _vm.fields.last_name.hasError,
                          },
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label",
                              attrs: { for: "last_name" },
                            },
                            [_vm._v(_vm._s(_vm.$t("lastName")))]
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.fields.last_name.value,
                                expression: "fields.last_name.value",
                              },
                            ],
                            staticClass: "emd-input eu-my_1",
                            attrs: {
                              id: "last_name",
                              type: "text",
                              disabled: _vm.activeStep.inviteSetAsEmployee,
                            },
                            domProps: { value: _vm.fields.last_name.value },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.fields.last_name,
                                    "value",
                                    $event.target.value
                                  )
                                },
                                function ($event) {
                                  _vm.fields.last_name.errors =
                                    _vm.getFeedbackError("last_name")
                                },
                              ],
                            },
                          }),
                          _vm._l(
                            _vm.fields.last_name.errors,
                            function (error, key) {
                              return _c(
                                "p",
                                { key: key, staticClass: "emd-input-feedback" },
                                [_vm._v(" " + _vm._s(error) + " ")]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "emd-form-group",
                          class: {
                            _state_error: _vm.fields.employee_type.hasError,
                          },
                        },
                        [
                          _c("label", { staticClass: "emd-label" }, [
                            _vm._v(_vm._s(_vm.$t("permission"))),
                          ]),
                          _c("div", { staticClass: "emd-select" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.fields.employee_type.value,
                                    expression: "fields.employee_type.value",
                                  },
                                ],
                                staticClass: "eu-my_1",
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.fields.employee_type,
                                        "value",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                    function ($event) {
                                      _vm.fields.employee_type.errors =
                                        _vm.getFeedbackError("employee_type")
                                    },
                                  ],
                                },
                              },
                              [
                                _c("option", { domProps: { value: null } }, [
                                  _vm._v(_vm._s(_vm.$t("select"))),
                                ]),
                                _vm._l(
                                  _vm.employeeTypes,
                                  function (type, index) {
                                    return _c(
                                      "option",
                                      {
                                        key: index,
                                        domProps: { value: type.key },
                                      },
                                      [_vm._v(" " + _vm._s(type.value) + " ")]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                            _c("div", { staticClass: "emd-select__arrow" }),
                          ]),
                          _vm._l(
                            _vm.fields.employee_type.errors,
                            function (error, key) {
                              return _c(
                                "p",
                                { key: key, staticClass: "emd-input-feedback" },
                                [_vm._v(" " + _vm._s(error) + " ")]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "emd-form-group",
                          class: { _state_error: _vm.fields.password.hasError },
                        },
                        [
                          _c("label", { staticClass: "emd-label" }, [
                            _vm._v(_vm._s(_vm.$t("employeePassword"))),
                          ]),
                          _c("div", { staticClass: "emd-input-group" }, [
                            _vm.inputType === "checkbox"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.fields.password.value,
                                      expression: "fields.password.value",
                                    },
                                  ],
                                  staticClass: "emd-input eu-my_1",
                                  attrs: {
                                    autocomplete: "current-password",
                                    type: "checkbox",
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.fields.password.value
                                    )
                                      ? _vm._i(
                                          _vm.fields.password.value,
                                          null
                                        ) > -1
                                      : _vm.fields.password.value,
                                  },
                                  on: {
                                    input: function ($event) {
                                      _vm.fields.password.errors =
                                        _vm.getFeedbackError("password")
                                    },
                                    change: function ($event) {
                                      var $$a = _vm.fields.password.value,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.fields.password,
                                              "value",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.fields.password,
                                              "value",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.fields.password,
                                          "value",
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                })
                              : _vm.inputType === "radio"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.fields.password.value,
                                      expression: "fields.password.value",
                                    },
                                  ],
                                  staticClass: "emd-input eu-my_1",
                                  attrs: {
                                    autocomplete: "current-password",
                                    type: "radio",
                                  },
                                  domProps: {
                                    checked: _vm._q(
                                      _vm.fields.password.value,
                                      null
                                    ),
                                  },
                                  on: {
                                    input: function ($event) {
                                      _vm.fields.password.errors =
                                        _vm.getFeedbackError("password")
                                    },
                                    change: function ($event) {
                                      return _vm.$set(
                                        _vm.fields.password,
                                        "value",
                                        null
                                      )
                                    },
                                  },
                                })
                              : _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.fields.password.value,
                                      expression: "fields.password.value",
                                    },
                                  ],
                                  staticClass: "emd-input eu-my_1",
                                  attrs: {
                                    autocomplete: "current-password",
                                    type: _vm.inputType,
                                  },
                                  domProps: {
                                    value: _vm.fields.password.value,
                                  },
                                  on: {
                                    input: [
                                      function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.fields.password,
                                          "value",
                                          $event.target.value
                                        )
                                      },
                                      function ($event) {
                                        _vm.fields.password.errors =
                                          _vm.getFeedbackError("password")
                                      },
                                    ],
                                  },
                                }),
                            _c(
                              "a",
                              {
                                staticClass: "emd-input-icon__link",
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleInput()
                                  },
                                },
                              },
                              [
                                _vm.inputType === "password"
                                  ? _c("i", { staticClass: "uil uil-eye" })
                                  : _vm._e(),
                                _vm.inputType === "text"
                                  ? _c("i", {
                                      staticClass: "uil uil-eye-slash",
                                    })
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm._l(
                            _vm.fields.password.errors,
                            function (error, key) {
                              return _c(
                                "p",
                                { key: key, staticClass: "emd-input-feedback" },
                                [_vm._v(" " + _vm._s(error) + " ")]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                ]
              ),
        ],
        1
      ),
      !_vm.isLoading
        ? _c("div", { staticClass: "emd-container__footer emd-ta_right" }, [
            _c(
              "button",
              {
                staticClass: "emd-btn _color_primary _type_text eu-mr_2",
                class: { _disabled: _vm.isLoading },
                attrs: { disabled: _vm.isLoading },
                on: { click: _vm.returnStepCheckUser },
              },
              [_vm._v(" " + _vm._s(_vm.$t("return")) + " ")]
            ),
            _c(
              "button",
              {
                staticClass: "emd-btn _color_primary",
                class: { _disabled: _vm.isLoading },
                attrs: {
                  form: "form-user-invite",
                  type: "submit",
                  disabled: _vm.isLoading,
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.activeStep.inviteSetAsEmployee
                        ? _vm.$t("save")
                        : _vm.$t("invite")
                    ) +
                    " "
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }